module.exports = __webpack_public_path__ + "static/img/contentPhoto.80f8ced.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/imgs/contentPhoto.png
// module id = yhH8
// module chunks = 1